import { AvatarPeer } from "./AvatarPeer";
import { ControllerPeer } from "./ControllerPeer";
import { NetworkObjectType } from "./NetworkObject";
export class NetworkObjectFactory {
    static create(mgr, type, ownerId, netUid) {
        switch (type) {
            case NetworkObjectType.Avatar:
                return new AvatarPeer(mgr, ownerId, netUid);
            case NetworkObjectType.Controller:
                return new ControllerPeer(mgr, ownerId, netUid);
        }
        return undefined;
    }
}
